import React, { FC } from 'react'
import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui'
import { ModalBase, MODAL_TYPES, IModalBaseProps } from './ModalBase'

type TPickedProps =
  | 'open'
  | 'className'
  | 'size'
  | 'onClose'
  | 'dataTest'
  | 'error'
  | 'children'
  | 'closeOnBackdropClick'
  | 'title'

interface IAlertModalProps extends Pick<IModalBaseProps, TPickedProps> {}

export const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    backgroundColor: brandColors.black,
    textAlign: 'center',
    height: '200px',
    overflow: 'auto',
  },
}))

export const AlertModal: FC<IAlertModalProps> = ({
  children,
  className,
  closeOnBackdropClick,
  dataTest,
  error,
  onClose,
  open,
  size,
  title,
}) => {
  const classes = useStyles()

  return (
    <ModalBase
      open={open}
      className={className}
      onClose={onClose}
      dataTest={dataTest}
      error={error}
      modalType={MODAL_TYPES.confirmation}
      title={title}
      closeOnBackdropClick={closeOnBackdropClick}
      headerClassName={classes.root}
      titleClass='justify-between items-center'
      size={size}>
      {children}
    </ModalBase>
  )
}
